import { useEffect, useState } from "react";
import { hieraApi } from "../lib/api";
import { t, type Lang } from "../lib/i18n";

type Tpl = {
  id: string;
  name: string;
  nameRu?: string;
  description?: string;
  descriptionRu?: string;
  pageCount?: number;
  builtin?: boolean;
};

export function TemplatesPage({ lang }: { lang: Lang }) {
  const [items, setItems] = useState<Tpl[]>([]);

  useEffect(() => {
    void hieraApi.templates().then((r) => setItems(r.templates)).catch(() => setItems([]));
  }, []);

  function title(row: Tpl): string {
    return lang === "ru" ? (row.nameRu || row.name) : row.name;
  }

  function desc(row: Tpl): string {
    return lang === "ru" ? (row.descriptionRu || row.description || "") : (row.description || "");
  }

  return (
    <div className="pad templates-page">
      <h1>{t(lang, "templates")}</h1>
      <p className="muted">{t(lang, "applyTemplateHint")}</p>
      {!items.length ? <p className="muted">{t(lang, "templatesEmpty")}</p> : null}
      <ul className="template-list">
        {items.map((it) => (
          <li key={it.id}>
            <div>
              <strong>{title(it)}</strong>
              {it.builtin ? <span className="pill">{t(lang, "templateBuiltin")}</span> : null}
              {it.pageCount ? (
                <span className="meta">
                  {it.pageCount} {t(lang, "templatePages")}
                </span>
              ) : null}
              {desc(it) ? <p className="muted">{desc(it)}</p> : null}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
